export default "/images/add_task_app_preview_1_movesense.webp"